import { createSelector } from 'reselect';

import {
  // Frame
  hasUserSelector,
  // Navigation
  premiumOfferSelector,
  proJobsOfferSelector,
  proBusinessOfferSelector,
  benefitsPlusOfferSelector,
  executivesOfferSelector,
  eRecruitingOfferSelector,
  advertisementOfferSelector,
  marketingSolutionsOfferSelector,
  halloFreelancerOfferSelector,
  mobileOfferSelector,
  premiumOfferPartnersSelector,
  xingEventsOfferSelector,
  salaryCheckOfferSelector,
  salaryCheckMatchOfferSelector,
  curriculumVitaeEditorSelector,
  coverLetterEditorSelector,
  jobApplicationTipsSelector,
  kununuOfferSelector,
  // Props
  localeSelector,
} from '../../selectors';
import { localizedLink } from '../../selectors/utils';

const offerLinksInputSelectors = [
  hasUserSelector,
  localeSelector,
  premiumOfferSelector,
  proJobsOfferSelector,
  proBusinessOfferSelector,
  benefitsPlusOfferSelector,
  executivesOfferSelector,
  eRecruitingOfferSelector,
  advertisementOfferSelector,
  marketingSolutionsOfferSelector,
  halloFreelancerOfferSelector,
  mobileOfferSelector,
  premiumOfferPartnersSelector,
  xingEventsOfferSelector,
  salaryCheckOfferSelector,
  salaryCheckMatchOfferSelector,
  curriculumVitaeEditorSelector,
  coverLetterEditorSelector,
  jobApplicationTipsSelector,
  kununuOfferSelector,
];
const offerLinksTransform = (
  hasUser,
  locale,
  premiumOffer,
  proJobsOffer,
  proBusinessOffer,
  benefitsPlusOffer,
  executivesOffer,
  eRecruitingOffer,
  advertisementOffer,
  marketingSolutionsOffer,
  halloFreelancerOffer,
  mobileOffer,
  premiumOfferPartners,
  xingEventsOffer,
  salaryCheckOffer,
  salaryCheckMatchOffer,
  curriculumVitaeEditor,
  coverLetterEditor,
  jobApplicationTips,
  kununuOffer
) => {
  const isDeutsch = locale === 'de';
  return [
    premiumOffer,
    proJobsOffer,
    proBusinessOffer,
    benefitsPlusOffer,
    executivesOffer,
    eRecruitingOffer,
    ...(hasUser
      ? [advertisementOffer, marketingSolutionsOffer]
      : [
          isDeutsch && halloFreelancerOffer,
          marketingSolutionsOffer,
          mobileOffer,
          advertisementOffer,
          premiumOfferPartners,
        ]),
    xingEventsOffer,
    ...(hasUser
      ? [salaryCheckMatchOffer]
      : [
          salaryCheckOffer,
          curriculumVitaeEditor,
          coverLetterEditor,
          jobApplicationTips,
          kununuOffer,
        ]),
  ]
    .filter(Boolean)
    .map(localizedLink(locale));
};
export default createSelector(
  ...offerLinksInputSelectors,
  offerLinksTransform
);
